import { render } from "./ArrowBoxRightIcon.vue?vue&type=template&id=b5f3e2f0"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__